import { type FC, type ReactNode } from "react";
import { Link } from "react-router-dom";

import snapchatSvg from "@app-assets/svg/snapchat.svg";

import {
    NavigationBox,
    NavigationContainer,
    OrangeLine,
    ghostImage,
    ghostImageContainer,
} from "./TopNavigation.styles";

interface TopNavigationProps {
    children?: ReactNode;
    leftContent?: ReactNode;
}

export const TopNavigation: FC<TopNavigationProps> = ({ children, leftContent }) => (
    <>
        <OrangeLine />
        <NavigationContainer justifyContent="space-between" alignItems="center">
            <NavigationBox justifyContent="flex-start" alignItems="center">
                {leftContent}
            </NavigationBox>

            <Link className={ghostImageContainer} to="/">
                <img className={ghostImage} src={snapchatSvg} alt="Snapchat ghost logo" />
            </Link>
            <NavigationBox justifyContent="flex-end" alignItems="center">
                {children}
            </NavigationBox>
        </NavigationContainer>
    </>
);
